import React from "react";
import { Menu, Text, Button, useMantineTheme, Group, ActionIcon } from '@mantine/core';
import { useWindowScroll } from '@mantine/hooks';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

import { numberFormatter } from "../../utils/globalFunctions";
import { utils } from "../../utils/globalVariables";

const AmountOfData = ({
    stateDataLimit,
    stateDataOffset = 0,
    stateAmountDataAll = 0,
    stateDataFlag,
    fnFirstData,
    fnLastData,
    fnPreviousData,
    fnNextData,
    stateSuffix = 'Data'
}) => {

    const theme = useMantineTheme();
    const [scroll] = useWindowScroll();

    const countDataFrom = Number(stateAmountDataAll) <= 0 ? 0 : Number(stateDataOffset) + 1;
    const countDataTo = Number(stateDataOffset) + Number(stateDataLimit);

    return (
        stateDataFlag !== 'idle' &&
        <Group spacing='xs' noWrap>
            <Menu shadow="md" width={150}>
                <Menu.Target>
                    <Button
                        variant='subtle'
                        size='xs'
                        radius='sm'
                        color="gray"

                        sx={() => ({
                            '&, &:hover': {
                                backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[1] : (scroll.y > utils.shrinkWhenScrollYAt ? theme.colors.dark[6] : theme.colors.dark[6])
                            }
                        })}
                    >
                        <Text c={theme.colorScheme === 'light' ? '#000' : theme.colors.gray[3]} fw='normal'>
                            {numberFormatter({ stateValue: countDataFrom })} - {numberFormatter({ stateValue: countDataTo > Number(stateAmountDataAll) ? stateAmountDataAll : countDataTo })} of {numberFormatter({ stateValue: stateAmountDataAll })}
                        </Text>
                    </Button>
                </Menu.Target>

                <Menu.Dropdown>
                    <Menu.Item
                        sx={{ textAlign: 'center' }}
                        onClick={() => fnFirstData(0)}
                    >
                        First data
                    </Menu.Item>

                    {/* <Menu.Divider /> 
                    
                    

                    */}

                    <Menu.Item
                        sx={{ textAlign: 'center' }}
                        onClick={() => fnLastData(
                            Number(stateAmountDataAll) <= Number(stateDataLimit) ? stateDataOffset : ((Math.ceil(Number(stateAmountDataAll) / Number(stateDataLimit)) - 1) * Number(stateDataLimit))
                        )}
                    >
                        Last data
                    </Menu.Item>
                </Menu.Dropdown>
            </Menu>

            <Group spacing='.5rem' noWrap>
                <ActionIcon
                    variant='subtle'
                    radius='xl'
                    title={'Previous'}
                    size='lg'
                    onClick={() => Number(stateDataOffset) <= 0 ? null : fnPreviousData(stateDataOffset - stateDataLimit)}
                    className={`${Number(stateDataOffset) <= 0 ? 'disabled' : 'idle'}`}
                    disabled={Number(stateDataOffset) <= 0}

                    sx={() => ({
                        '&.idle': {
                            backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[1] : (scroll.y > utils.shrinkWhenScrollYAt ? theme.colors.dark[6] : theme.colors.dark[6]),
                        },

                        '&.disabled': {
                            backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[0] : (scroll.y > utils.shrinkWhenScrollYAt ? theme.colors.dark[8] : theme.colors.dark[8])
                        },

                        '&': {
                            borderColor: 'transparent !important'
                        }
                    })}
                >
                    <IconChevronLeft
                        size='1.25rem'
                        strokeWidth={1.25}
                        style={{
                            color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                        }}
                    />
                </ActionIcon>

                <ActionIcon
                    variant='subtle'
                    radius='xl'
                    title={'Next'}
                    size='lg'
                    onClick={() => countDataTo >= Number(stateAmountDataAll) ? null : fnNextData(stateDataOffset + stateDataLimit)}
                    className={`${countDataTo >= Number(stateAmountDataAll) ? 'disabled' : 'idle'}`}
                    disabled={countDataTo >= Number(stateAmountDataAll)}

                    sx={() => ({
                        '&.idle': {
                            backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[1] : (scroll.y > utils.shrinkWhenScrollYAt ? theme.colors.dark[6] : theme.colors.dark[6]),
                        },

                        '&.disabled': {
                            backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[0] : (scroll.y > utils.shrinkWhenScrollYAt ? theme.colors.dark[8] : theme.colors.dark[8])
                        },

                        '&': {
                            borderColor: 'transparent !important'
                        }
                    })}
                >
                    <IconChevronRight
                        size='1.25rem'
                        strokeWidth={1.25}
                        style={{
                            color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                        }}
                    />
                </ActionIcon>
            </Group>
        </Group>
    )
}

export default React.memo(AmountOfData);